import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { HttpBackendService } from 'src/app/core/backend-services/http/http.backend-service';

@Injectable({
  providedIn: 'root',
})
export class BugReportBackendService {
  private readonly BASE_ADDRESS = '/bug-report';

  constructor(private http: HttpBackendService) {}

  public submit(
    reportText: string,
    clientData?: any,
    browserInfo?: any,
    reportType?: 'manual' | 'triggered_by_chat' | 'auto_server_error'
  ): Promise<{ id: number; message: string }> {
    const payload: any = {
      reportText,
    };

    if (clientData) {
      payload.clientData = clientData;
    }

    if (browserInfo) {
      payload.browserInfo = browserInfo;
    }

    if (reportType) {
      payload.reportType = reportType;
    }

    return firstValueFrom(
      this.http.post<{ id: number; message: string }>(
        `${this.BASE_ADDRESS}/submit`,
        payload
      )
    );
  }
}